import { Box } from '@mui/material'
import { TokenAmount } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { XyoWorldMinterEvents } from '@xyo-network/world-typechain'

import { parseBigNumber } from '../../../parseBigNumber'
import GeotokenIdentification from '../../GeotokenIdentification'
import EventStringFragment from './EventStringFragment'

interface TokensFlowedEventProps {
  event: XyoWorldMinterEvents.TokensFlowed
}

const TokensFlowedEventCard: React.FC<TokensFlowedEventProps> = (props) => {
  const { event } = props
  const { to, from, amount } = event.args
  const quadkeyTo = Quadkey.fromBase10String(to.toString())
  const quadkeyFrom = Quadkey.fromBase10String(from.toString())
  const amountBN = parseBigNumber(amount)
  return (
    <Box alignItems="center" display="flex" flexWrap="wrap">
      <TokenAmount amount={amountBN} />
      <EventStringFragment>tokens flowed to</EventStringFragment>
      <GeotokenIdentification icon={false} quadkey={quadkeyTo} />
      <EventStringFragment>from</EventStringFragment>
      <GeotokenIdentification icon={false} quadkey={quadkeyFrom} />
    </Box>
  )
}

export default TokensFlowedEventCard
